module.exports = __webpack_public_path__ + "img/acculv.6c7ea40f.png";